export default __webpack_public_path__ + "static/media/silver_personal.03490089.svg";